import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { Reel } from '@/types/reel.type';
import { DataState, SUCCESS_DATA_STATE } from '@/types/data.type';

import { ReelsSliceState } from './reels.type';

const reelsInitialState: ReelsSliceState = {
    data: {},
    dataStateMap: {},
};

// TODO: Merge with the "library" slice, both cache reels by code
export const REELS_REDUCER_NAME = 'reels';

export const reelsSlice = createSlice({
    name: REELS_REDUCER_NAME,
    initialState: reelsInitialState,
    reducers: {
        upsertReels: (
            state,
            action: PayloadAction<{
                reels: Reel[];
            }>,
        ) => {
            action.payload.reels.forEach((reel) => {
                state.data[reel.code] = reel;
                state.dataStateMap[reel.code] = SUCCESS_DATA_STATE;
            });
        },
        resetReels: () => reelsInitialState,
        setReelName: (
            state,
            action: PayloadAction<{
                reelCode: string;
                name: string;
            }>,
        ) => {
            const reel = state.data[action.payload.reelCode];

            if (reel) {
                reel.name = action.payload.name;
            }
        },
        setReelsDataState: (
            state,
            action: PayloadAction<Record<string, DataState>>,
        ) => {
            Object.assign(state.dataStateMap, action.payload);
        },
    },
});

export const { upsertReels, resetReels, setReelName, setReelsDataState } =
    reelsSlice.actions;

export const reelsReducer = reelsSlice.reducer;
